// ABOUTME: An AppBar entry that groups several nav items behind a single button and a dropdown.
// ABOUTME: Highlights itself when the current route belongs to one of its items.

import { Button, ExpandMoreIcon, Menu } from '@ds/coolshop';
import { resolveIcon } from '@src/_new/modules/custom-pages/utils/resolveIcon';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { NavCandidate } from '../types';
import { NavGroupMenuItem } from './NavGroupMenuItem';

type NavGroupButtonProps = {
    id: string;
    label: string;
    iconName?: string;
    items: NavCandidate[];
};

export const NavGroupButton = ({ id, label, iconName, items }: NavGroupButtonProps) => {
    const { pathname } = useLocation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [open, setOpen] = useState(false);

    // Keep `open` separate from `anchorEl` so the anchor stays valid while the menu plays its
    // close transition. Nulling the anchor on close orphans the transitioning menu into a screen
    // corner when the close coincides with the route change.
    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const active = items.some(item => pathname.startsWith(`/${item.dest}`));

    return (
        <>
            <Button
                id={`app-bar-group-${id}`}
                variant="text"
                color={active ? 'secondary' : 'primary'}
                startIcon={resolveIcon(iconName)}
                endIcon={<ExpandMoreIcon />}
                onClick={handleOpen}
            >
                {label}
            </Button>

            <Menu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                {items.map(item => (
                    <NavGroupMenuItem key={item.id} item={item} onNavigate={handleClose} />
                ))}
            </Menu>
        </>
    );
};
